import React from 'react';
import { Provider } from 'react-redux';

import { ModalContext } from '@notino/react-styleguide-v20';

import { ApplicationBuildContextProvider } from '@context/ApplicationBuildContext';
import { ApplicationRuntimeContextProvider } from '@context/ApplicationRuntimeContext';
import store from '@context/Store';
import { TrackingContextProvider } from '@context/TrackingContext';
import { UserContextProvider } from '@context/UserContext';
import { ValidationContextProvider } from '@context/ValidationContext';
import { ErrorBoundary, ErrorContextProvider, ErrorModalHandler } from '@services/errorService';
import { HttpClientContextProvider } from '@services/httpClientService';
import { LocalizationContextProvider } from '@services/localizationService';
import { NewRelicProvider } from '@services/newRelicService';
import { ReactFCV } from '@types';
import '@notino/react-styleguide/dist/styleguide.css';

import { ApplicationRoutes } from './routes';

import '@notino/react-styleguide/dist/styleguide.css';

export const AppLayout: ReactFCV = () => (
  <ApplicationBuildContextProvider>
    <Provider store={store}>
      <NewRelicProvider>
        <ErrorContextProvider>
          <ErrorBoundary>
            <HttpClientContextProvider>
              <ApplicationRuntimeContextProvider>
                <UserContextProvider>
                  <TrackingContextProvider>
                    <ValidationContextProvider>
                      <LocalizationContextProvider>
                        <ModalContext.Provider>
                          <ErrorModalHandler>
                            <ApplicationRoutes />
                          </ErrorModalHandler>
                        </ModalContext.Provider>
                      </LocalizationContextProvider>
                    </ValidationContextProvider>
                  </TrackingContextProvider>
                </UserContextProvider>
              </ApplicationRuntimeContextProvider>
            </HttpClientContextProvider>
          </ErrorBoundary>
        </ErrorContextProvider>
      </NewRelicProvider>
    </Provider>
  </ApplicationBuildContextProvider>
);
